<div class="account-settings-theme-wrapper">
  <div class="account-settings-theme-item" (click)="onThemePreferenceSelection('dark')">
    <div class="account-settings-theme-item-description">
      <span class="ods-typography-body-m-bold">{{ 'enable_' | translate }}</span>
    </div>
    <mat-icon *ngIf="themePreference === 'dark'" class="account-settings-theme-item-icon">check</mat-icon>
  </div>
  <div class="account-settings-theme-item" (click)="onThemePreferenceSelection('light')">
    <div class="account-settings-theme-item-description">
      <span class="ods-typography-body-m-bold">{{ 'disable_' | translate }}</span>
    </div>
    <mat-icon *ngIf="themePreference === 'light'" class="account-settings-theme-item-icon">check</mat-icon>
  </div>
  <div class="account-settings-theme-item" (click)="onThemePreferenceSelection('system')">
    <div class="account-settings-theme-item-description">
      <span class="ods-typography-body-m-bold">{{ 'system_default' | translate }}</span>
      <span class="account-settings-theme-item-description-subtitle ods-typography-body-s-regular">{{
        'device_mode_applied' | translate
      }}</span>
    </div>
    <mat-icon *ngIf="themePreference === 'system'" class="account-settings-theme-item-icon">check</mat-icon>
  </div>
</div>
